import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './ExtendTextContent.module.scss';

interface ExtendTextContentProps {
  children: React.ReactNode;
  isExtended?: boolean;
  action?: React.ReactNode;
  numberOfLines?: string;
  actionSpacing?: 'default' | 'dense';
  onFocus?: (event: React.FocusEvent<HTMLDivElement>) => void;
}

export const ExtendTextContent = forwardRef<HTMLDivElement, ExtendTextContentProps>(
  ({ children, isExtended, action, numberOfLines, actionSpacing = 'default', onFocus }, ref) => (
    <div
      className={clsx(styles.extendTextContent, {
        [styles.extendTextContentDense]: actionSpacing === 'dense',
      })}
    >
      <div
        ref={ref}
        className={clsx(styles.textContent, {
          [styles.textContentTruncated]: !isExtended,
        })}
        style={
          {
            '--line-clamp': numberOfLines,
          } as React.CSSProperties
        }
        onFocus={onFocus}
      >
        {children}
      </div>
      {action}
    </div>
  ),
);

ExtendTextContent.displayName = 'ExtendTextContent';
